import { FeedsListPageState } from './feeds_list_types';

// PAGE STORE
export function feedsListPageStateVM(): FeedsListPageState {
    return {
        init: false,
        canEdit: false,
        loading: false,
        action: 'QUERY',
    };
}
